<template>
  <div class="fullHeight">
    <div class="mainContainer">
      <div v-if="viewState === 'loading'" class="fullHeight">
        <v-skeleton-loader
          v-for="n in 4"
          :key="n"
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </div>
      <div ref="notifications" v-if="viewState === 'notifications'">
        <div class="notifications-wrapper">
          <div ref="notificationList" v-scroll="handleScroll">
            <notification-list
              class="notificationContainer"
              v-for="(subscribe, index) in notifsData"
              :key="`${subscribe.key}-${index}`"
              :source="subscribe"
            />
          </div>
        </div>
      </div>
      <div>
        <div class="circle-loader" v-if="viewState === 'notifications'"></div>
      </div>
      <div v-if="viewState === 'no-notifications'" class="emptyPosts">
        <img :src="require('@/assets/img/noNotifications.png')" class="emptyContentImg"/>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from '@/components/notifications/index'
import { mapActions, mapGetters } from 'vuex'
import { _ } from 'vue-underscore'

export default {
  name: 'Notification',
  beforeMount: function () {
    this.next()
  },
  data () {
    return {
      totalResults: 20,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2
      },
      showloader: false,
      startFirstLoad: false,
      lastScrollLimit: 0
    }
  },
  computed: {
    ...mapGetters(['getNotifsData', 'getNotifsRefs']),
    notifsData () {
      return _.compact(this.getNotifsData)
    },
    notifsRefs () {
      return this.getNotifsRefs
    },
    finishFirstLoad () {
      return _.isEmpty(this.getNotifsData) === _.isEmpty(this.getNotifsRefs)
    },
    loading () {
      return !this.startFirstLoad || !this.finishFirstLoad
    },
    hasContent () {
      return !_.isEmpty(this.notifsData)
    },
    viewState () {
      let viewState = false
      if (!viewState && this.loading) viewState = 'loading'
      if (!viewState && this.hasContent) viewState = 'notifications'
      if (!viewState && !this.hasContent) viewState = 'no-notifications'
      return viewState
    }
  },
  components: {
    'notification-list': Notifications
  },
  methods: {
    ...mapActions({
      nextPageAction: 'GET_NEXT_NOTIFS'
    }),
    next () {
      this.nextPageAction()
        .then(this.nextFinished)
        .catch(error => console.log({ nextPageAction: error }))
    },
    nextFinished () {
      this.startFirstLoad = true
    },
    handleScroll () {
      const scrollPos = window.scrollY + window.innerHeight
      const scrollLimit = this.$refs.notifications.offsetHeight
      if (
        scrollLimit > this.lastScrollLimit &&
        scrollPos > scrollLimit - 5 * window.innerHeight
      ) {
        this.next()
        this.lastScrollLimit = scrollLimit
      }
      this.showLast = scrollPos > scrollLimit - 250
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Notification.vue